import * as React from 'react';
import { MotionSource } from '../../motion/MotionSource';
import { ButtonIcon } from './ButtonIcon';
import ButtonTooltip from './ButtonTooltip';

interface Props {
  options: MotionSource[];
  selectedOption: MotionSource;
  didOpen: () => void;
  didClose: () => void;
  didSelect: (source: MotionSource) => void;
}

interface State {
  isOpen: boolean;
}

export default class MotionSourceSelector extends React.Component<
  Props,
  State
> {
  el = React.createRef<HTMLDivElement>();
  state: State = {
    isOpen: false
  };

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.didClickOnWindow);
  }

  didSelect = (source: MotionSource) => {
    if (!this.state.isOpen) {
      this.setState({ isOpen: true });
      this.props.didOpen();
      window.addEventListener('mousedown', this.didClickOnWindow);
      return;
    }
    if (source === this.props.selectedOption) {
      return;
    }
    this.props.didSelect(source);
  };

  didClickOnWindow = (e: MouseEvent) => {
    if (
      this.el.current &&
      e.target &&
      !this.el.current.contains(e.target as HTMLElement)
    ) {
      this.close();
    }
  };

  close = () => {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
      this.props.didClose();
      window.removeEventListener('mousedown', this.didClickOnWindow);
    }
  };

  render() {
    return (
      <div className="motion-source-selector" ref={this.el}>
        {this.state.isOpen === true ? (
          <>
            {this.props.options.map((s, index) => (
              <ButtonIcon
                key={index}
                icon={s.type}
                active={s === this.props.selectedOption}
                onClick={() => {
                  this.didSelect(s);
                }}
              />
            ))}
          </>
        ) : (
          <ButtonTooltip text="Change default motion" placement="topLeft">
            <ButtonIcon
              icon={this.props.selectedOption.type}
              onClick={() => this.didSelect(this.props.selectedOption)}
            />
          </ButtonTooltip>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/components/MotionSourceSelector.tsx